import { render, staticRenderFns } from "./personDevice.vue?vue&type=template&id=539bb9ca&scoped=true&"
import script from "./personDevice.vue?vue&type=script&lang=js&"
export * from "./personDevice.vue?vue&type=script&lang=js&"
import style0 from "./personDevice.vue?vue&type=style&index=0&id=539bb9ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539bb9ca",
  null
  
)

export default component.exports